




































































import { Component, Prop, Vue } from 'vue-property-decorator';
import StepIdTooltip from '@/components/Steps/StepIdTooltip.vue';
import { Module } from '@/interfaces/Module';
import { Step } from '@/interfaces/Step';

@Component({
  components: { StepIdTooltip }
})
export default class SelectBlueprintStepDialog extends Vue {
  @Prop({ default: () => false })
  value!: boolean;

  @Prop({ default: () => 0 })
  cutoverplan_id!: number;

  selectedBlueprint?: number = -1;

  submit() {
    this.$emit('close', this.selectedBlueprint);
    this.selectedBlueprint = undefined;
  }

  filter = '';

  get allFilteredModules() {
    if (!this.filter) return this.$store.state.fullBlueprints;
    const filter = this.filter.toLowerCase();
    return this.$store.state.fullBlueprints.filter(
      (module: Module) =>
        this.getModuleName(module)
          .toLowerCase()
          .includes(filter) ||
        module.steps.find((step: any) => {
          if (!step.stepLanguages?.length) return false;
          for (const language of step.stepLanguages) {
            if (language?.name?.includes(this.filter)) {
              return true;
            }
          }
          return false;
        })
    );
  }

  getModuleName(module: Module) {
    const preferredLanguage = module.moduleLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    return preferredLanguage?.name || module.moduleLanguages?.[0]?.name;
  }

  getStepName(step: Step) {
    const stepLanguage =
      step.stepLanguages.find((sL: any) => sL.langaugeId === this.$store.state.user.languageId) ||
      step.stepLanguages[0];
    return stepLanguage?.name || '';
  }

  getFilteredStepsFromModule(module: Module) {
    if (!this.filter) return module.steps;
    const filter = this.filter.toLowerCase();

    if (
      this.getModuleName(module)
        .toLowerCase()
        .includes(filter)
    ) {
      return module.steps;
    }

    return module.steps.filter((step: Step) => {
      if (!step.stepLanguages?.length) return false;
      for (const language of step.stepLanguages) {
        if (language?.name?.includes(this.filter)) {
          return true;
        }
      }
      return false;
    });
  }
}
